import { isNil } from 'lodash'
import SFAuthService, { NO_USER } from '../SFAuthService'

export interface sfResource {
  Number__c: string
  Name: string
  Centre_Priority__c: string
  Topic__c: string
  Location__c: string
  Type__c: string
  Description__c: string
  Id: string
  Year__c: string
  Resource_Name__c: string
  // Resource_Entry_ID: string | number
  'Stage__c': 'Published' | 'Removed' | 'In progress' | 'More info required' | 'Submitted' | 'Rejected' | 'In review' | (string & {})
  Resource_name_submission__c: string
  Last_Modified_By_User_Date__c: string
  Resource_URL__c: string
  Resource_topic_submission__c: string
  Description_submission__c: string
  // Organization_Name: string
  // Sources_of_resource_submission__c: string
  Organization__c: string
  LastModifiedDate: string
  LastModifiedById: string
  Last_Modified_User_Data__c: string
  'Last Modified': string
  'Last Modified By': {
    id: string
    email: string
    name: string
  }
  Resource_type_submission__c: string
  Geographical_scope_submission__c: string
  Language_of_Resource_submission__c: string
  Access_submission__c: string
  Year_submission__c: string
  Language_of_Entry__c: string
  Global_ID__c: string
  Language_of_Resource__c: string
  Access__c: string
  Resource_Entry_Status__c: string
  OwnerId: string
  URL_submission__c: string
  Current_number_of_Saves__c: number
  Date_published__c: string
  CONTROL_Publish_to_Website_Status__c: string
  Sources__r: {
    records: Array<{
      Id: string
      Display_Name__c?: string
      Organization__r?: {
        Name?: string
        Id: string
      }
      Contact__r?: {
        Name?: string
        Id: string
      }
    }>
  }
}

export interface Resource {
  number: string
  systemName: string
  centrePriority: string[]
  topic: string[]
  location: string[]
  type: string
  description: string
  id: string
  year: string
  name: string
  entryLanguage: string
  language: string[]
  access: string
  url: string
  globalId: string
  currentNumberOfSaves: number
  datePublished: string
  controlPublishToWebsiteStatus: string
  stage: string
  lastModifiedByUserDate: string
  lastModifiedUserData: string
  ownerId: string
  resourceNameSubmission: string
  sources: Array<{
    id: string
    name?: string
    organizationId: string
    organizationName?: string
    contactId: string
    contactName?: string
  }>
}

export const getResources = async (values?: Partial<sfResource>): Promise<sfResource[]> => {
  const conn = SFAuthService.getConnection()
  if (isNil(conn)) {
    return await Promise.reject(NO_USER)
  }
  const res = await conn.sobject('Resource__c').find({
    ...values
  }).select('Number__c, Name, Current_number_of_Saves__c, Organization_Name__c, CONTROL_Publish_to_Website_Status__c, Last_Modified_User_Data__c, Last_Modified_By_User_Date__c, LastModifiedById, URL_submission__c, Access_submission__c, Language_of_Resource_submission__c, Resource_name_submission__c, Year_submission__c, Description_submission__c, Resource_type_submission__c, Geographical_scope_submission__c, Resource_topic_submission__c, OwnerId, Stage__c, Resource_Entry_Status__c, Centre_Priority__c, Topic__c, Location__c, Type__c, Description__c, Id, Year__c, Resource_Name__c, Language_of_Entry__c, Language_of_Resource__c, Access__c, Resource_URL__c, Global_ID__c, Date_published__c')
    .run({ autoFetch: true, maxFetch: 10000 })
  return res as unknown as sfResource[]
}

export const getResource = async (id: string): Promise<sfResource> => {
  const conn = SFAuthService.getConnection()
  if (isNil(conn)) {
    return await Promise.reject(NO_USER)
  }
  return await conn
    .sobject('Resource__c')
    .retrieve(id) as unknown as sfResource
}

export const createResource = async (values?: Partial<sfResource>): Promise<any> => {
  const conn = SFAuthService.getConnection()
  if (isNil(conn)) {
    return await Promise.reject(NO_USER)
  }
  return await conn.sobject('Resource__c').create(values ?? {})
}

export const updateResource = async (values?: Partial<sfResource>): Promise<any> => {
  const conn = SFAuthService.getConnection()
  if (isNil(conn)) {
    return await Promise.reject(NO_USER)
  }
  return await conn.sobject('Resource__c').update(values ?? {})
}
